export default __webpack_public_path__ + "static/media/dolci1.88cbf25c.jpg";